// LIBRARIES //
import React from 'react';

// COMPONENTS //
import { TenantAutopayStatus } from 'components/shared/StatusHelper';

const AutoPayStatus = ({ residentData }) => {
  // if (hostIsCapreit()) return; // TODO (Chris M): determine if this is still relevant or move to feature toggle

  // wrapped in a div so it displays properly using flex
  return (
    <div>
      <TenantAutopayStatus style={{ fontSize: '90%' }} tenantDetails={residentData} />
    </div>
  );
};

export default AutoPayStatus;
